import { axios, Response } from '../index'

export interface Body {
  name: string
  parentFolderId?: string
}

const shareFolderGroupPermission = (
  personId: string,
  folderId: string,
  permissionName: string
): Response<null> => {
  const body = {
    personId: personId,
    folderId: folderId,
    permissionName: permissionName
  }

  return axios.post(
    `/v1/folders/${folderId}/person/${personId}/permissions/${permissionName}`,
    body
  )
}

export default shareFolderGroupPermission
